import React, { Component } from "react";
import classes from "./Channels.module.css";
import constants from "../../../../globalization";
import checkFilledImg from '../../../../assets/images/Fireboard/checkfilled.png';
import checkImg from '../../../../assets/images/Fireboard/checkbox.png';
import PopupHeader from "../PopupHeader";
import FireboardUtils from "../../../../util/fireboard-util";
import Button from "../../../../components/Button";

const config = [
  {
    id: 0,
    name: "Curbside",
    checked: false,
    type: "curbside",
  },
  {
    id: 1,
    name: "Online",
    checked: false,
    type: "online",
  },
  {
    id: 2,
    name: "Walk Up",
    checked: false,
    type: "walkup",
  },
];

const orderConfig = [
  {
    id: 101,
    name: "Venue Ordering",
    checked: false,
    type: "venueOrder",
  },
  {
    id: 102,
    name: "Food Runner",
    checked: false,
    type: "foodRunner",
  }
];
class Channels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prepTime: props.prepTime,
      production: props.production,
      channelArr: config.map((c) => {
        const { countStatus } = props || {};
        return {
          ...c,
          checked: countStatus[c.type],
        };
      }),
      orderSettingsArr: orderConfig.map(orderSetting => {
        const { venueOrder, foodRunner } = props || {};
        return {
          ...orderSetting,
          checked: orderSetting.type === 'venueOrder' ? venueOrder : foodRunner,
        };
      }),
    };
  }

  onChangePrepTime = (e) => {
    e.stopPropagation();
    this.setState({ prepTime: e.target.value });
  };

  onChangeProdRate = (e) => {
    e.stopPropagation();
    this.setState({ production: e.target.value });
  };

  get renderChannels() {
    const { channelArr = [] } = this.state || {};
    const { onToggleCount } = this.props || {};
    return (
      Array.isArray(channelArr) &&
      channelArr.length &&
      channelArr.map((channel) => {
        return (
          <div className={classes.channel} key={channel.id} onClick={() => onToggleCount(channel.type)}>
            <div>
              <img src={channel.checked ? checkFilledImg : checkImg} className={classes.checkbox} alt="" />
            </div>
            <span className={classes.channelNameText}>{channel.name}</span>
          </div>
        );
      })
    );
  }

  get renderOrderSettings() {
    const { orderSettingsArr = [] } = this.state || {};
    const { onToggleOrderSettings } = this.props || {};
    return (
      Array.isArray(orderSettingsArr) &&
      orderSettingsArr.length &&
      orderSettingsArr.map((orderSetting) => {
        return (
          <div className={classes.channel} key={orderSetting.id} onClick={() => onToggleOrderSettings(orderSetting.type)}>
            <div>
              <img src={orderSetting.checked ? checkFilledImg : checkImg} className={classes.checkbox} alt="" />
            </div>
            <span className={classes.channelNameText}>{orderSetting.name}</span>
          </div>
        );
      })
    );
  }

  render() {
    const { prepTime, production } = this.state || {};
    const { onUpdate, onClose, deviceGroup } = this.props || {};
    let disablePreProd = false;
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup) && !deviceGroup?.fireBoardSettings?.enableUpdatePrepProdSettings) {
      disablePreProd = true;
    }
    return (
      <div className={classes.container}>
        <PopupHeader title={constants.channelSettings} onClose={onClose} containerStyle={classes.heading} />

        <div className={classes.prepProdContainer}>
          <div className={classes.settingsContainer}>
            <div className={classes.headerText}>
              {constants.updateChannelSettings}
            </div>
            <div className={classes.channelContainer}>{this.renderChannels}</div>
          </div>

          <div className={classes.headerText}>
            {constants.channelsUpdateTimeRate}
          </div>
          <div className={classes.prepTimeContainer}>
            <span className={classes.subText}>
              {constants.channelsPrepTime}
            </span>
            <input
              disabled={disablePreProd}
              className={classes.inputContainer}
              type="number"
              value={prepTime}
              onChange={(e) => this.onChangePrepTime(e)}
            />
            <Button disabled={disablePreProd} onClick={() => onUpdate("prepTime", prepTime)} className={classes.button}>
              <span className={classes.updateButton}>
                {constants.channelsUpdate}
              </span>
            </Button>
          </div>

          <div className={classes.prepTimeContainer}>
            <span className={classes.subText}>
              {constants.channelsProductionRate}
            </span>
            <input
              disabled={disablePreProd}
              className={classes.inputContainer}
              type="number"
              value={production}
              onChange={(e) => this.onChangeProdRate(e)}
            />
            <Button disabled={disablePreProd} onClick={() => onUpdate("productionRate", production)} className={classes.button}>
              <span className={classes.updateButton}>
                {constants.channelsUpdate}
              </span>
            </Button>
          </div>

          <div className={classes.settingsContainer}>
            <div className={classes.headerText}>
              {constants.updateOrderSettings}
            </div>
            <div className={classes.channelContainer}>{this.renderOrderSettings}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Channels;
